// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3rBjQ","title":"AfterBackImages_title__4-8G5","images":"AfterBackImages_images__2h6qG"};